import React from "react";
import Block from "components/shared/Block";

const GridFilterBlock = (props) => (
  <Block className={`grid-filter-block  ${props.className || ""}`}>{props.children}</Block>
);
export default GridFilterBlock;
